import { evaluateHours, type HoursSchedule } from "@starsach/shared-types";

export interface HoursNow {
  open: boolean;
  reason: "open" | "closed" | "holiday";
  holiday?: string;
  announcement?: string;
}

/**
 * The same decision the lander makes at call time, for the screen's
 * "right now" line - not authoritative, and never sent anywhere. The
 * reading itself is shared/types `evaluateHours`, so a holiday window
 * (#265) closes here exactly when it closes in the customer's account.
 */
export function hoursNow(schedule: HoursSchedule, now: Date = new Date()): HoursNow {
  const reading = evaluateHours(schedule, now);
  if (reading.holiday) {
    const announcement = reading.holiday.announcement ?? schedule.closed_announcement;
    return { open: false, reason: "holiday", holiday: reading.holiday.name, ...(announcement ? { announcement } : {}) };
  }
  if (reading.open) return { open: true, reason: "open" };
  return { open: false, reason: "closed", ...(schedule.closed_announcement ? { announcement: schedule.closed_announcement } : {}) };
}
